import { useState, useEffect, useRef } from "react";
import { API_URL } from "../helpers";

import Alert from "../components/Alert";

import Questions from "./Questions";
import Complete from "./Complete";

const Survey = () => {
	const [details, setDetails] = useState({});
	const [question, setQuestion] = useState(0);
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const urlString = window.location.href;
	const url = new URL(urlString);
	const searchParams = new URLSearchParams(url.search);
	const searchParamsQ = searchParams.get("q") ? searchParams.get("q") : "";
	const searchParamsOpen = searchParams.get("open")
		? searchParams.get("open")
		: "no"; // value or null

	useEffect(() => {
		const init = async () => {
			const url = new URL(
				`${API_URL}/surveyInit?q=${searchParamsQ}&open=${searchParamsOpen}`,
			);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setDetails({
						...json,
						text: "Your survey response has been recorded, thank you.",
					});
					setQuestion(1);
					setAlert({});
				} else {
					setAlert({
						type: "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();

		// eslint-disable-next-line
	}, []);

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<div id="full-column">
					<h1>Benefit For Children Survey</h1>

					{question < 8 ? (
						<Questions
							details={details}
							setDetails={setDetails}
							question={question}
							setQuestion={setQuestion}
							q={searchParamsQ}
						/>
					) : (
						<Complete text={details.text} />
					)}
				</div>
			)}
		</>
	);
};

export default Survey;
